// UI translations (ES default / EN). Article titles & bodies remain in their
// original Spanish per the requirement of not altering migrated content.

// `group` splits the nav into "content" (editorial sections) and "more"
// (utility links). The sidebar renders a subtle divider between groups.
export const SECTIONS = [
  { key: "inicio", icon: "home", path: "/", group: "content" },
  { key: "capital", icon: "landmark", path: "/seccion/capital", group: "content" },
  { key: "route", icon: "route", path: "/seccion/route", group: "content" },
  { key: "tiempo", icon: "clock", path: "/seccion/tiempo", group: "content" },
  { key: "vagabundeando", icon: "footprints", path: "/seccion/vagabundeando", group: "content" },
  { key: "opiniones", icon: "message-square-quote", path: "/seccion/opiniones", group: "content" },
  { key: "eventos", icon: "calendar-days", path: "/seccion/eventos", group: "more" },
  { key: "archivo", icon: "archive", path: "/seccion/archivo", group: "more" },
  { key: "contacto", icon: "mail", path: "/contacto", group: "more" },
];

export const translations = {
  es: {
    nav: {
      inicio: "Inicio",
      capital: "Capital",
      route: "Route",
      tiempo: "Tiempo",
      vagabundeando: "Vagabundeando",
      opiniones: "Opiniones",
      eventos: "Eventos",
      archivo: "Archivo",
      contacto: "Contacto",
    },
    brandTagline: "Guanajuato",
    searchPlaceholder: "Buscar…",
    themeDark: "Modo Oscuro",
    themeLight: "Modo Claro",
    langLabel: "Idioma",
    hero: {
      overline: "Cultura & Tradición",
      title: "Leyendas que cobran vida",
      subtitle:
        "Descubre los secretos mejor guardados del patrimonio cultural de Guanajuato. Un viaje inmersivo a través de sus calles e historia.",
      cta: "Explorar historias",
      scroll: "Desliza para descubrir",
    },
    recentTitle: "Historias recientes",
    recentSubtitle: "Lo último del corazón de la Capital",
    viewAll: "Ver todo el archivo",
    featured: "Destacado",
    partnersTitle: "Nuestros Socios",
    readMore: "Leer historia",
    back: "Volver",
    backHome: "Volver al inicio",
    share: "Compartir",
    watchVideo: "Ver en Facebook",
    swipeGallery: "Desliza para ver más",
    articlesCount: "historias",
    sectionDesc: {
      capital: "Patrimonio, monumentos e historia viva del centro de Guanajuato.",
      route: "La ruta inmersiva por tradiciones, festividades y rincones mágicos.",
      tiempo: "Crónicas a través del tiempo y la memoria colonial.",
      vagabundeando: "Recorridos libres por callejones, plazas y miradores.",
      opiniones: "Voces, ensayos y miradas sobre la cultura guanajuatense.",
      eventos: "Festividades, agenda cultural y celebraciones de la ciudad.",
      archivo: "Todo el acervo de Capital Route en un solo lugar.",
    },
    emptyTitle: "Próximamente",
    emptyText: "Estamos preparando nuevas historias para esta sección. Vuelve pronto.",
    searchResultsFor: "Resultados para",
    noResults: "No encontramos historias que coincidan con tu búsqueda.",
    contact: {
      title: "Hablemos",
      subtitle:
        "¿Tienes una historia, una leyenda o una colaboración para Guanajuato? Escríbenos.",
      nameLabel: "Nombre",
      emailLabel: "Correo",
      messageLabel: "Mensaje",
      send: "Enviar mensaje",
      sent: "¡Gracias! Hemos recibido tu mensaje.",
      followUs: "Síguenos",
    },
    footer: "Cultura, Tradición y Leyenda en Guanajuato.",
  },
  en: {
    nav: {
      inicio: "Home",
      capital: "Capital",
      route: "Route",
      tiempo: "Time",
      vagabundeando: "Wandering",
      opiniones: "Opinions",
      eventos: "Events",
      archivo: "Archive",
      contacto: "Contact",
    },
    brandTagline: "Guanajuato",
    searchPlaceholder: "Search…",
    themeDark: "Dark Mode",
    themeLight: "Light Mode",
    langLabel: "Language",
    hero: {
      overline: "Culture & Tradition",
      title: "Legends that come to life",
      subtitle:
        "Discover the best-kept secrets of Guanajuato's cultural heritage. An immersive journey through its streets and history.",
      cta: "Explore stories",
      scroll: "Scroll to discover",
    },
    recentTitle: "Recent stories",
    recentSubtitle: "The latest from the heart of the Capital",
    viewAll: "View full archive",
    featured: "Featured",
    partnersTitle: "Our Partners",
    readMore: "Read story",
    back: "Back",
    backHome: "Back to home",
    share: "Share",
    watchVideo: "Watch on Facebook",
    swipeGallery: "Swipe to see more",
    articlesCount: "stories",
    sectionDesc: {
      capital: "Heritage, monuments and the living history of downtown Guanajuato.",
      route: "The immersive route through traditions, festivities and magical corners.",
      tiempo: "Chronicles across time and colonial memory.",
      vagabundeando: "Free walks through alleys, plazas and lookouts.",
      opiniones: "Voices, essays and perspectives on Guanajuato's culture.",
      eventos: "Festivities, cultural agenda and city celebrations.",
      archivo: "The entire Capital Route collection in one place.",
    },
    emptyTitle: "Coming soon",
    emptyText: "We're preparing new stories for this section. Check back soon.",
    searchResultsFor: "Results for",
    noResults: "We couldn't find stories matching your search.",
    contact: {
      title: "Let's talk",
      subtitle:
        "Do you have a story, a legend or a collaboration for Guanajuato? Write to us.",
      nameLabel: "Name",
      emailLabel: "Email",
      messageLabel: "Message",
      send: "Send message",
      sent: "Thank you! We've received your message.",
      followUs: "Follow us",
    },
    footer: "Culture, Tradition and Legend in Guanajuato.",
  },
};
